import './Search.css';
import {useState} from 'react';
import SearchBar from './SearchBar';
import FadeIn from '../../utils/fadein';
import icon_filter from '../../assets/design/search/filter.png';
import BuyerResults from './BuyerResults';
import SearchFilters from './SearchFilters';
import SellerSearch from './SellerSearch';
import BrowseSellers from './BrowseSellers';

const Search = ({userType}) => {
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [query, setQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [selectedCompany, setSelectedCompany] = useState(0);
  const [selectedIndustry, setSelectedIndustry] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(0);

  function removeFilter(type, id){
    let filter = selectedFilters.filter(item => {
      if (item.type===type && item.value === id)
      {
        return false;
      }
      return true;
    });

    setSelectedFilters(filter);
  }

  return (
    <div>

      <div className="" style={{display:"flex"}}>
        {userType ==='Buyer' && (
      <SearchFilters userType={userType} setSelectedFilters={setSelectedFilters} selectedFilters={selectedFilters} removeFilter={removeFilter} showFilter={showFilter} setShowFilter={setShowFilter} />
        )}
        
      <div className='search__results' style={{width: "100%"}}>

      {userType==="Seller" && (
        <>

        <SellerSearch selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters}  query={query} selectedCategory={selectedCategory} selectedCompanyId={selectedCompanyId} setSelectedCompanyId={setSelectedCompanyId} />
        </>
      )}
      
      {userType === "Buyer" && (
        <BuyerResults selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} query={query} selectedIndustry={selectedIndustry} selectedCompanyId={selectedCompanyId} setSelectedCompanyId={setSelectedCompanyId} />
      )}
      </div>
      </div>
    </div>
  )
}

export default Search;